/**
 * Where a miniature's image sits on the grid it occupies at the table.
 *
 * The api's flattened miniature (and the copy it stores for commission review —
 * both go through `cropSquareCentered`) is a SQUARE CROP CENTERED ON THE FOOTPRINT
 * CENTER, never smaller than the footprint and never larger than the canvas. For
 * those, `naturalWidth / cellPx` is exactly the image's width in grid cells, and
 * drawing it centered puts every pixel where the VTT will.
 *
 * Most miniatures on record are NOT that: app uploads carry no size at all, and
 * older art predates the sized template, at whatever resolution it was made (64px
 * and 2048px both occur). Their pixel size carries no cell meaning, so they are
 * placed at footprint size — how a VTT puts an arbitrary image on the board. The
 * range check is what tells the two apart: an image outside footprint..canvas
 * cannot have come from the crop.
 *
 * @param {object} args
 * @param {number} args.naturalWidth   The image's intrinsic width in pixels.
 * @param {number} args.cellPx         Source pixels per grid cell (the api's cell size).
 * @param {number} args.footprintCells Cells the miniature occupies (0 = unknown).
 * @param {number} args.canvasCells    Cells of authoring canvas for the size (0 = unknown).
 * @returns {{imageCells: number, gridCells: number, isFootprintCrop: boolean}}
 */
export function gridPlacement({ naturalWidth, cellPx, footprintCells, canvasCells }) {
    const cells = cellPx > 0 ? naturalWidth / cellPx : 0;
    const isFootprintCrop = canvasCells > 0 && cells >= footprintCells && cells <= canvasCells;
    const imageCells = isFootprintCrop ? cells : Math.max(footprintCells, 1);
    const gridCells = Math.max(canvasCells, Math.ceil(imageCells), footprintCells, 1);
    return { imageCells, gridCells, isFootprintCrop };
}
